import React, { useEffect, createElement } from 'react';
import { Helmet } from 'react-helmet-async';
export function Booking() {
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup script on unmount
      document.body.removeChild(script);
    };
  }, []);
  return <div className="w-full bg-black" data-id="element-107">
      <Helmet data-id="element-108">
        <title data-id="element-109">Book Appointment - Western Royal Diesel</title>
        <meta name="description" content="Schedule your diesel performance upgrade, vehicle wrap, or window tinting appointment" data-id="element-110" />
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black text-white py-16 md:py-24 border-b border-cyan-500/20" data-id="element-111">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent" data-id="element-113">
            Book an Appointment
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl" data-id="element-114">
            Schedule your service online. Choose your preferred date and time,
            and we'll take care of the rest.
          </p>
        </div>
      </section>
      {/* Calendly Widget Section */}
      <section className="py-16 md:py-24 bg-gray-950" data-id="element-115">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
          <div className="calendly-inline-widget" data-url="https://calendly.com/westernroyaldiesel/30min?background_color=1a1a1a&text_color=ffffff&primary_color=57d8e0" style={{
          minWidth: '320px',
          height: '700px'
        }} data-id="element-117" />
        </div>
      </section>
    </div>;
}